import type from './Pom.type';

const initState = {
  pomList: [],
  GradingList: [],
  BrandList: [],
  CategoryOneList: [],
  CategoryTwoList: [],
  CategoryThreeList: [],
  GradingDataById: [],
  GroupInsertId: '',
  UnitOfMeasure: [],
  ecommAcess: {},
  eCommSpecData: [],
  foundReferences: false,
  ProfileData: {},
  updatedExcelPOMData: [],
  GradingListingData: [],
  pomGroupDataById: [],
  pomGroupsData: [],
  pomGroupList: [],
  categoryFourList: [],
  totalRecords: 0,
  gradingNames: [],
};

const PomReducer = (state = initState, action) => {
  switch (action.type) {
    case type.GET_GRADING_LIST:
      return {
        ...state,
        GradingList: action.payload,
      };
    case type.GET_GRADING_NAME:
      return {
        ...state,
        gradingNames: action.payload,
      };
    case type.GET_ALL_POM:
      return {
        ...state,
        pomList: action?.payload?.data,
        totalRecords: action?.payload?.totalRecords,
      };
    case type.GET_ALL_BRAND:
      return {
        ...state,
        BrandList: action.payload,
      };
    case type.GET_CATEGORY_ONE_DATA:
      return {
        ...state,
        CategoryOneList: action.payload,
      };
    case type.GET_CATEGORY_TWO_DATA:
      return {
        ...state,
        CategoryTwoList: action.payload,
      };
    case type.GET_CATEGORY_THREE_DATA:
      return {
        ...state,
        CategoryThreeList: action.payload,
      };
    case type.GET_GRADING_GROUP_DATA_BY_ID:
      return {
        ...state,
        GradingDataById: action.payload,
      };
    case type.GET_INSERTED_GROUP_ID:
      return {
        ...state,
        GroupInsertId: action.payload.insertedId,
      };
    case type.FETCH_UNIT_OF_MEASURE:
      return {
        ...state,
        UnitOfMeasure: action.payload,
      };
    case type.SYSTEM_ECOMM_ACCESS:
      return {
        ...state,
        ecommAcess: action.payload,
      };
    case type.ECOMM_SPEC_DATA:
      return {
        ...state,
        eCommSpecData: action.payload,
      };
    case type.CHECK_GRADING_REFERENCE:
      return {
        ...state,
        foundReferences: action.payload,
      };
    case type.DEFAULT_COMPANY_UNIT:
      return {
        ...state,
        ProfileData: action.payload,
      };
    case type.UPDATE_EXCEL_DATA:
      return {
        ...state,
        updatedExcelPOMData: action.payload,
      };
    case type.GRADING_GROUP_LISTING_DATA:
      return {
        ...state,
        GradingListingData: action.payload?.doc,
        totalListCount: action.payload?.totalCount,
      };
    case type.CLEAR_GROUP_REDUCER:
      return {
        ...state,
        GradingListingData: [],
        totalListCount: 0,
        pomGroupsData: [],
        totalPomGroupCount: 0,
        pomGroupDataById: [],
      };
    case type.CLEAR_GRADING_GROUP_REDUCER:
      return {
        ...state,
        GradingDataById: [],
        foundReferences: false,
        updatedExcelPOMData: [],
        GroupInsertId: '',
      };

    case type.POM_GROUP_DATA_BY_ID:
      return {
        ...state,
        pomGroupDataById: action.payload,
      };

    case type.POM_GROUPS_DATA:
      return {
        ...state,
        pomGroupsData: action?.payload?.doc,
        totalPomGroupCount: action?.payload?.totalCount,
      };
    case type.POM_GROUPS_WITH_LIBRARIES:
      return {
        ...state,
        pomGroupList: action?.payload,
      };
    case type.GET_CATEGORY_FOUR_DATA:
      return {
        ...state,
        CategoryFourList: action.payload,
      };
    default:
      return state;
  }
};

export default PomReducer;
